import { prepareCommonRailData, sendRail } from "~/features/configurator/Rail/api/sendRailCommon";
import { type LinearConfiguratorState } from "~/features/configurator/Linear/redux/types";
import { type LinearConfiguration } from "~/features/configurator/Linear/models";

export function sendRailStepChange(linearState: LinearConfiguratorState): Promise<LinearConfiguration> {
  const data = prepareCommonRailData(linearState);

  data.cpqAction = "NAV_TO_CSTIC_IN_GROUP";
  data.railsConfiguratorData.navigation = true;

  return sendRail(data);
}

export function sendRailMiscChange(linearState: LinearConfiguratorState): Promise<LinearConfiguration> {
  const data = prepareCommonRailData(linearState);

  data.cpqAction = "TOGGLE_GROUP";

  return sendRail(data);
}
